/* global app */
app.controller('dialog_searchUserCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', function ($rootScope, $scope, $http, NetworkService, MainService) {
    
        $scope.selectedUser = {};
        $scope.guiListeners = []
        
        $scope.addUser = function(user){
                $scope.searches.userSearchAddUser.searchField = user.Vorname+" "+user.Nachname
                $scope.dialogInitVars.selectedUser = user;
        }
        
        NetworkService.callOperation("getUsers", {}, function(response){
                $scope.users = response.getData().users;
        })
        
    }])